import { Grid, Stack, Text, Title } from '@mantine/core';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { FlowStep } from '../../../components/layout/FlowStep.tsx';
import { Button } from '../../../components/ui/Button/Button.tsx';
import { useLoggedInUser } from '../../../hooks/useLoggedInUser.ts';

const communityContentItems: { title: string; text: string }[] = [
  {
    title: 'Accurate Information',
    text: 'Make sure all event details you provide are accurate and presented respectfully.',
  },
  {
    title: 'Review Process',
    text: 'Our team will review your submission within 1-2 business days and publish it to the Gogigi website.',
  },
  {
    title: 'Major Edits',
    text: 'Any significant changes to your event will require re-approval by the Gogigi curation team.',
  },
  {
    title: 'Engaging Content',
    text: 'Craft engaging and accessible content to make your event stand out or let us help you craft it.',
  },
];

export const CommunityNotes: FC = () => {
  const { user } = useLoggedInUser();

  const navigate = useNavigate();

  const agreeWithCommunityNotes = () => {
    user.mutate(
      { has_agreed_to_community_notes: true },
      {
        onSuccess: () => {
          void navigate('/dashboard');
        },
        onError: (error) => {
          console.error('Failed to save community notes agreement:', error);
          void navigate('/dashboard');
        },
      },
    );
  };

  return (
    <FlowStep
      bodyContent={
        <Stack gap="md">
          <Text c="gigi-grey-text" size="sm" ta="center">
            Your support means the world to us. Together, we can showcase the beautiful diversity of the LGBTQ+
            community. To ensure this we&apos;re asking you to commit to the following:
          </Text>
          <Grid gap="md">
            {communityContentItems.map((item) => (
              <Grid.Col key={item.title} span={{ base: 12, sm: 6 }}>
                <Title mb="xxxs" order={4}>
                  {item.title}
                </Title>
                <Text c="gigi-grey-text" size="sm">
                  {item.text}
                </Text>
              </Grid.Col>
            ))}
          </Grid>
          <Stack gap="md" mt="md">
            <Button
              loading={user.isPending}
              text="Agree and continue"
              type="button"
              onClick={agreeWithCommunityNotes}
            />
          </Stack>
        </Stack>
      }
      customTopTitle="Community Note"
      heading="A big welcome to the Gogigi community from our team."
    />
  );
};
